import React, { useRef, useEffect } from 'react';
import Dragula from 'react-dragula';
import PropTypes from 'prop-types';
import './DraggableList.scss';

export default function DraggableList({
  columns = [],
  data = [],
  onChange,
  width = '100%',
}) {
  const tmpData = useRef();
  useEffect(() => {
    tmpData.current = [...data];
  }, [data]);

  const findDOMIndex = (el, container) =>
    Array.from(container.children).indexOf(el);

  const move = (array, from, to) => {
    array.splice(to, 0, array.splice(from, 1)[0]);
  };

  const dragulaDecorator = useRef((component) => {
    // Keep track of the last dragging index to do some reordering.
    let dragIndex;

    // Use dragula on the container to make its children draggable
    Dragula([component], {
      direction: 'vertical',
    })
      // When we drag an item, memorize its index.
      .on('drag', (el, source) => {
        dragIndex = findDOMIndex(el, source);
      })

      // When we drop an item, reorder the array
      .on('drop', (el, target) => {
        const dataOrder = [...tmpData.current];
        move(dataOrder, dragIndex, findDOMIndex(el, target));
        tmpData.current = [...dataOrder];
        onChange(tmpData.current);
      });
  }).current;

  const renderDataRow = (item, idx) => (
    <div key={idx} className="order-row">
      <div className="row-handle">||</div>
      {Array.isArray(columns) &&
        columns.map((col, colIdx) => (
          /* eslint-disable react/no-array-index-key */
          <div
            key={`${idx}_${colIdx}`}
            style={{ width: col.width || '100%' }}
            className="order-item"
          >
            {col.format && col.format(item)}
          </div>
        ))}
    </div>
  );

  return (
    <div className="order-container">
      <div className="order-items" style={{ width }}>
        <div className="order-header">
          <div className="row-handle">||</div>
          {columns.map((col, idx) => (
            /* eslint-disable react/no-array-index-key */
            <div
              key={idx}
              style={{ width: col.width || '100%' }}
              className="order-item"
            >
              {col.displayName}
            </div>
          ))}
        </div>
        <div ref={dragulaDecorator}>{data.map(renderDataRow)}</div>
      </div>
    </div>
  );
}

DraggableList.propTypes = {
  onChange: PropTypes.func,
  columns: PropTypes.array,
  data: PropTypes.array,
  width: PropTypes.string,
};
